import moment from "moment";
import { observable, action } from "mobx";
import { inject, observer } from "mobx-react";
import React from "react";
import { withRouter, RouteComponentProps } from "react-router-dom";
import { ReadDataStyled } from "./styled";
import { t } from "i18next";
import TopFilter from "../common/TopFilter/TopFilter";
import parseObjectToUrlParams from "../../../utils/parseObjectToUrlParams";
import AuthStore from "../../../stores/auth/auth.store";
import axios from "axios"; // Moved this to the top for better readability
import { DatePicker, Divider } from "antd";
import { cn } from "../../../utils";
import ConcreteSlump from "../Concrete/ConcreteSlump/ConcreteSlump";

interface Props extends RouteComponentProps<any> {
  authStore?: AuthStore;
}

// function getDateFromSearch(
//   search: string
// ): [moment.Moment, moment.Moment] | undefined {
//   const searchParams = new URLSearchParams(search);
//   const date = searchParams.get("date");
//   if (date) {
//     const [start, end] = date.split(",");
//     return [moment(+start), moment(+end)];
//   }
//   return undefined;
// }
function getBoxUrl(
  displayMode: "month" | "week" | "day",
  concreate_code: string
) {
  return `/concrete/slump?date=${moment()
    .subtract(1, displayMode)
    .valueOf()}-${moment().valueOf()}&lct=${concreate_code}`;
}

@inject("authStore")
@observer
class SlumpChanges extends React.PureComponent<Props> {
  @observable data: any = [];
  @observable filters: any = {};
  @observable displayMode: "month" | "week" | "day" = "month";
  @observable activeSlump: any = "";
  @observable dateFormat = "DD/MM/YYYY";
  @observable currentDate: any = moment().format("DD/MM/YYYY");
  @observable group_id = this.props.authStore!.getUserGroipID();

  @observable concreateCode: any = null;

  componentDidMount = async () => {
    await this.fetchData();
  };

  fetchData = async () => {
    try {
      const current_date = this.data[0]?.date;
      this.currentDate = moment(current_date).format("DD/MM/YYYY/");

      this.filters.date = this.currentDate;
      const rsp = await axios.get(
        `${process.env.REACT_APP_API_URL}/mixtures_behavior/calculate/${this.group_id}?` +
          parseObjectToUrlParams(this.filters)
      );

      this.data = rsp.data.data; // Ensure data is assigned properly

      console.log({ ma: this.currentDate });
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  onChange = async (date: any, dateString: string) => {
    console.log({ date, dateString });
    this.filters.date = dateString;
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/mixtures_behavior/calculate/${this.group_id}?` +
        parseObjectToUrlParams(this.filters)
    );
    this.data = response.data.data;
  };

  slumStatus = (range: number) => {
    // Function to switch between class names based on the value of condition / 25

    const result = Math.abs(range) / 25; // Get absolute value of condition and divide by 25

    if (result < 1) {
      return "box-items green";
    } else if (result >= 1 && result <= 2) {
      return "box-items orange";
    } else {
      return "box-items red";
    }
  };

  changeConcreateCode = (concreate_code: string) => {
    this.concreateCode = concreate_code;
  };

  render() {
    return (
      <ReadDataStyled>
        <div className="p-5 flex flex-col">
          <div className="flex gap-4 m-5">
            <DatePicker
              onChange={this.onChange}
              defaultValue={moment(this.currentDate, this.dateFormat)}
              format={this.dateFormat}
            />

            <div className="rounded-md overflow-hidden">
              <button
                className={cn("rounded-none bg-slate-400 hover:bg-slate-500", {
                  "bg-main-orange hover:bg-orange-500":
                    this.displayMode === "month",
                })}
                onClick={() => (this.displayMode = "month")}
              >
                {t("month")}
              </button>
              <button
                className={cn("rounded-none bg-slate-400 hover:bg-slate-500", {
                  "bg-main-orange hover:bg-orange-500":
                    this.displayMode === "week",
                })}
                onClick={() => (this.displayMode = "week")}
              >
                {t("week")}
              </button>
              <button
                className={cn("rounded-none bg-slate-400 hover:bg-slate-500", {
                  "bg-main-orange hover:bg-orange-500":
                    this.displayMode === "day",
                })}
                onClick={() => {
                  this.displayMode = "day";
                }}
              >
                {t("day")}
              </button>
            </div>
          </div>
          <div className="flex mx-5">
            <h1 className="text-2xl font-semibold">{t("mixDesignBehavior")}</h1>
          </div>

          <div className="slump-statuses">
            {this.data && this.data.length > 0 ? (
              this.data?.map((raw: any) => (
                <a
                  href={getBoxUrl(this.displayMode, raw.mixture_code)}
                  onClick={() => this.changeConcreateCode(raw.mixture_code)}
                  className={this.slumStatus(
                    this.displayMode === "day"
                      ? raw.slump_deviation_day
                      : this.displayMode === "week"
                      ? raw.slump_deviation_week
                      : this.displayMode === "month"
                      ? raw.slump_deviation_month
                      : null
                  )}
                  key={raw.id}
                >
                  <h3 className="bold text-center">{raw.mixture_name}</h3>{" "}
                  {/* Example property */}
                  <p className="text-center black">{raw.mixture_code}</p>{" "}
                  {/* Example property */}
                  <Divider />
                  <div className="mx-auto">
                    <table className="min-w-full">
                      {this.displayMode === "month" && (
                        <div className="flex flex-col">
                          <div className="flex gap-3">
                            <div className="flex gap-3 flexCol">
                              <div className="flex gap-2">
                                <div className="flex">
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      opacity="0.99"
                                      d="M5.80821 23C5.3678 24.4615 4.77337 26.4341 4.3884 27.7117C4.19498 28.3535 4.67556 29 5.34593 29H24.6544C25.3248 29 25.8056 28.3543 25.6122 27.7124C25.0092 25.7114 23.829 21.7949 22.9868 19M5.80821 23C7.66642 16.8335 10.503 7.42034 10.8417 6.29617C10.8642 6.22155 10.8775 6.14588 10.8821 6.06808L10.9393 5.10185C10.9723 4.54433 10.5291 4.07407 9.9706 4.07407C9.43465 4.07407 9.00017 3.6396 9.00017 3.10365V2C9.00017 1.44772 9.44789 1 10.0002 1H20.0002C20.5525 1 21.0002 1.44772 21.0002 2V3.10365C21.0002 3.6396 20.5657 4.07407 20.0298 4.07407C19.4713 4.07407 19.028 4.54433 19.061 5.10185L19.1182 6.06808C19.1228 6.14588 19.1355 6.2194 19.158 6.29402C19.4471 7.25345 21.5832 14.3421 22.9868 19M5.80821 23C12.1737 23 16.7595 19 22.9868 19M16.0002 15C16.0002 16.1046 15.1047 17 14.0002 17C12.8956 17 12.0002 16.1046 12.0002 15C12.0002 13.8954 12.8956 13 14.0002 13C15.1047 13 16.0002 13.8954 16.0002 15Z"
                                      stroke="#FF6700"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  <div className="black text-xl  ml-3">
                                    {t("slumpChanges")}:
                                  </div>
                                </div>

                                <div className="black text-xl bold">
                                  {raw.slump_deviation_month !== null
                                    ? +raw.slump_deviation_month + " " + t("mm")
                                    : "-"}
                                </div>
                              </div>

                              <div className="flex gap-2">
                                <div className="flex gap-2">
                                  <svg
                                    className="fire-icon"
                                    width="25"
                                    height="25"
                                    viewBox="0 0 25 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1044_7395)">
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.259 0.0421831C12.6151 0.133436 12.9134 0.36967 13.0793 0.69093C13.7003 1.89972 14.1644 2.63353 14.6311 3.22854C15.1043 3.83106 15.6031 4.32355 16.3643 5.06233C18.1206 6.77113 19 9.01246 19 11.25C19 13.4876 18.1206 15.7289 16.3643 17.4377C12.8491 20.8541 7.15086 20.8541 3.63572 17.4377C1.87943 15.7289 1 13.4876 1 11.25C1 9.01246 1.87943 6.77113 3.63572 5.06233C4.00343 4.70481 4.55628 4.59856 5.03714 4.79231C5.518 4.98482 5.83043 5.44113 5.83043 5.94614C5.83043 7.34618 5.92043 8.41246 6.34214 9.26373C6.57357 9.73125 6.93486 10.1888 7.55715 10.5975C7.70629 9.27125 7.97886 7.65493 8.34658 6.12239C8.63586 4.91485 8.99585 3.7098 9.42528 2.70477C9.63999 2.20101 9.883 1.72346 10.1581 1.30969C10.4256 0.907181 10.7702 0.498489 11.215 0.20973C11.5223 0.0109736 11.9029 -0.0503198 12.259 0.0421831ZM12.727 16.4014C11.2214 17.8664 8.77857 17.8664 7.273 16.4014C6.51957 15.6701 6.14286 14.7101 6.14286 13.7501C6.14286 13.7501 7.273 14.3751 9.35714 14.3751C9.35714 13.1251 10 9.37497 10.9643 8.74995C11.6071 9.99999 11.9749 10.3663 12.727 11.0988C13.4804 11.8301 13.8571 12.7901 13.8571 13.7501C13.8571 14.7101 13.4804 15.6701 12.727 16.4014Z"
                                        fill="#FF6700"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1044_7395">
                                        <rect
                                          width="25"
                                          height="25"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <div className="black text-xl">
                                    {t("yourSaving")}:
                                  </div>
                                </div>

                                <div className="black text-xl bold">
                                  {raw.slump_deviation_month < 0
                                    ? "0 " + t("$")
                                    : Math.round(
                                        (raw.slump_deviation_month / 25) *
                                          raw.total_cube_month *
                                          0.5
                                      ) +
                                      " " +
                                      t("$")}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="black text-xl flex">
                            <div className="flex">
                              <svg
                                width="100"
                                height="100"
                                viewBox="0 0 100 100"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0807 14.0694C10.4213 14.0399 9.87595 14.3369 9.58538 14.8415C7.45238 18.4711 5.3988 22.1258 3.32622 25.791C3.12933 26.1395 3.07361 26.5502 3.1706 26.9385L7.74822 45.249L3.20416 58.8783C3.15101 59.0378 3.12447 59.2048 3.12478 59.3725C3.12166 63.5453 3.13104 67.7005 3.13104 71.8694C3.12792 72.7323 3.82453 73.4347 4.68743 73.4381H12.622C13.3895 78.7206 17.9547 82.8039 23.4435 82.8039C28.9323 82.8039 33.484 78.7206 34.2498 73.4381H60.9405C63.0243 73.4381 63.0243 70.3131 60.9405 70.3131H34.2528C33.491 65.0261 28.9355 60.9352 23.4434 60.9352C20.4764 60.9352 17.7781 62.1331 15.8018 64.0631H6.24981V59.6259L10.858 45.8045C10.9519 45.5228 10.9636 45.2198 10.8916 44.9317L6.35362 26.786L7.43393 24.8755L15.3868 45.6124L15.6249 59.4001C15.6405 60.2522 16.3351 60.9353 17.1874 60.9352H23.4434H47.0854C47.6466 60.9357 48.165 60.6352 48.4435 60.1478L53.8451 50.6966L56.2498 52.375V64.0631H37.4205C35.2578 64.1724 35.421 67.2976 37.5028 67.1882H66.6959C66.0166 68.6106 65.6217 70.1931 65.6217 71.8696C65.6217 77.8917 70.5341 82.804 76.5562 82.804C82.0449 82.804 86.607 78.7206 87.3746 73.4383H95.3123C96.18 73.4414 96.8842 72.7373 96.8809 71.8696V65.6195C96.8778 64.7566 96.1752 64.0598 95.3123 64.0631H93.7559V46.8757C93.7549 46.7234 93.7305 46.5727 93.6857 46.4268L89.0318 30.8994C88.2409 28.2606 86.8346 26.5629 84.3779 26.5629H67.1904C64.6205 26.5629 62.4968 28.6776 62.4968 31.2474V59.3664C62.4968 61.4502 65.6218 61.4502 65.6218 59.3664V31.2474C65.6218 30.3547 66.2977 29.691 67.1904 29.691H84.3779C85.416 29.691 85.7295 30.7798 86.0045 31.696L90.6279 47.1075V64.063H84.1978C82.2215 62.1329 79.5232 60.9348 76.5562 60.9348C73.5893 60.9348 70.8972 62.133 68.9237 64.063H59.3748V51.5599C59.3749 51.049 59.1253 50.5705 58.7065 50.2781L54.2295 47.1531C53.4765 46.6287 52.436 46.8632 51.9804 47.6599L48.361 53.9923L33.6576 51.3952L47.0457 28.1957L56.6099 39.6429L55.1054 42.2431C54.0595 44.0489 56.7717 45.6143 57.8123 43.8055L59.86 40.2594C60.1878 39.6919 60.1269 38.9805 59.7074 38.4772L48.01 24.4817C47.8934 24.34 47.753 24.2207 47.5949 24.1274L36.7673 17.8775C36.595 17.7783 36.4055 17.7134 36.2088 17.685L11.0807 14.0694ZM11.7613 17.3193L33.4806 20.4505L22.3722 39.6888C21.3306 41.4935 24.0375 43.056 25.0791 41.2514L36.5599 21.3691L44.6836 26.0567L30.615 50.4097L24.127 46.6652C23.2944 46.1845 22.4098 46.5381 22.0243 47.196C21.6212 47.8843 21.6768 48.856 22.5279 49.3475L30.4075 53.8977C30.5643 53.9887 30.7357 54.0518 30.9141 54.0837L46.713 56.8761L46.179 57.81H18.7223L18.5087 45.2824C18.5056 45.1005 18.4703 44.9209 18.405 44.7515L9.42974 21.3567L11.7613 17.3193ZM70.3184 32.804C69.4543 32.7993 68.7502 33.4962 68.7468 34.3604V43.7507C68.7499 44.6148 69.4543 45.312 70.3184 45.3071H74.3528L77.017 47.9836C77.3122 48.2741 77.7107 48.4353 78.1248 48.4323H85.6565C86.6964 48.4264 87.4402 47.4247 87.1458 46.4273L83.4074 33.9243C83.2112 33.2601 82.6014 32.8043 81.909 32.8042L70.3184 32.804ZM71.8748 35.9291H80.7432L83.5569 45.3071H78.7718L76.1076 42.6429C75.8144 42.3482 75.4157 42.1822 74.9998 42.1822H71.8748V35.9291ZM70.3184 51.5572C68.2331 51.5572 68.2331 54.6851 70.3184 54.6851H73.4434C75.5288 54.6851 75.5288 51.5572 73.4434 51.5572H70.3184ZM23.4434 64.0631C27.7766 64.0631 31.2498 67.5364 31.2498 71.8696C31.2498 76.2028 27.7766 79.6913 23.4434 79.6913C19.1102 79.6913 15.6218 76.2028 15.6218 71.8696C15.6218 67.5364 19.1102 64.0631 23.4434 64.0631ZM76.5562 64.0631C80.8894 64.0631 84.3779 67.5364 84.3779 71.8696C84.3779 76.2028 80.8894 79.6913 76.5562 79.6913C72.223 79.6913 68.7468 76.2028 68.7468 71.8696C68.7468 67.5364 72.223 64.0631 76.5562 64.0631ZM6.24369 67.1882H13.571C13.1055 68.1609 12.7782 69.2096 12.6188 70.3132H6.24369V67.1882ZM23.4434 67.1882C20.8731 67.1882 18.7468 69.2993 18.7468 71.8696C18.7467 74.4399 20.8731 76.5662 23.4434 76.5662C26.0138 76.5662 28.1248 74.4399 28.1248 71.8696C28.1248 69.2993 26.0137 67.1882 23.4434 67.1882ZM76.5562 67.1882C73.9859 67.1882 71.8748 69.2993 71.8748 71.8696C71.8748 74.4399 73.9859 76.5662 76.5562 76.5662C79.1266 76.5662 81.2529 74.4399 81.2529 71.8696C81.2528 69.2993 79.1265 67.1882 76.5562 67.1882ZM86.4286 67.1882H93.7559V70.3132H87.3777C87.2184 69.2097 86.8941 68.1608 86.4286 67.1882ZM23.4434 70.3132C24.3249 70.3132 24.9998 70.9882 24.9998 71.8696C24.9998 72.751 24.3249 73.4383 23.4434 73.4383C22.562 73.4383 21.8717 72.7511 21.8718 71.8696C21.8718 70.9881 22.562 70.3132 23.4434 70.3132ZM76.5562 70.3132C77.4377 70.3132 78.1248 70.9882 78.1248 71.8696C78.1248 72.751 77.4377 73.4383 76.5562 73.4383C75.6748 73.4383 74.9998 72.7511 74.9998 71.8696C74.9998 70.9881 75.6748 70.3132 76.5562 70.3132Z"
                                  fill="#FF6700"
                                />
                              </svg>
                            </div>
                            <Divider type="vertical" />

                            <div className="flex flexCol items-start justify-center">
                              <div className="black text-xl ">
                                {raw.total_cube_month !== null
                                  ? raw.total_cube_month + " " + t("kob")
                                  : "-"}
                              </div>
                              <div className="black text-xl ">
                                {raw.number_of_deliveries_month !== null
                                  ? raw.number_of_deliveries_month +
                                    " " +
                                    t("deliveries")
                                  : `0  ${t("deliveries")}`}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {this.displayMode === "week" && (
                        <div className="flex flex-col">
                          <div className="flex gap-3">
                            <div className="flex gap-3 flexCol">
                              <div className="flex gap-2">
                                <div className="flex">
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      opacity="0.99"
                                      d="M5.80821 23C5.3678 24.4615 4.77337 26.4341 4.3884 27.7117C4.19498 28.3535 4.67556 29 5.34593 29H24.6544C25.3248 29 25.8056 28.3543 25.6122 27.7124C25.0092 25.7114 23.829 21.7949 22.9868 19M5.80821 23C7.66642 16.8335 10.503 7.42034 10.8417 6.29617C10.8642 6.22155 10.8775 6.14588 10.8821 6.06808L10.9393 5.10185C10.9723 4.54433 10.5291 4.07407 9.9706 4.07407C9.43465 4.07407 9.00017 3.6396 9.00017 3.10365V2C9.00017 1.44772 9.44789 1 10.0002 1H20.0002C20.5525 1 21.0002 1.44772 21.0002 2V3.10365C21.0002 3.6396 20.5657 4.07407 20.0298 4.07407C19.4713 4.07407 19.028 4.54433 19.061 5.10185L19.1182 6.06808C19.1228 6.14588 19.1355 6.2194 19.158 6.29402C19.4471 7.25345 21.5832 14.3421 22.9868 19M5.80821 23C12.1737 23 16.7595 19 22.9868 19M16.0002 15C16.0002 16.1046 15.1047 17 14.0002 17C12.8956 17 12.0002 16.1046 12.0002 15C12.0002 13.8954 12.8956 13 14.0002 13C15.1047 13 16.0002 13.8954 16.0002 15Z"
                                      stroke="#FF6700"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  <div className="black text-xl  ml-3">
                                    {t("slumpChanges")}:
                                  </div>
                                </div>

                                <div className="black text-xl bold">
                                  {raw.slump_deviation_week !== null
                                    ? +raw.slump_deviation_week + " " + t("mm")
                                    : "-"}
                                </div>
                              </div>

                              <div className="flex gap-2">
                                <div className="flex gap-2">
                                  <svg
                                    className="fire-icon"
                                    width="25"
                                    height="25"
                                    viewBox="0 0 25 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1044_7395)">
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.259 0.0421831C12.6151 0.133436 12.9134 0.36967 13.0793 0.69093C13.7003 1.89972 14.1644 2.63353 14.6311 3.22854C15.1043 3.83106 15.6031 4.32355 16.3643 5.06233C18.1206 6.77113 19 9.01246 19 11.25C19 13.4876 18.1206 15.7289 16.3643 17.4377C12.8491 20.8541 7.15086 20.8541 3.63572 17.4377C1.87943 15.7289 1 13.4876 1 11.25C1 9.01246 1.87943 6.77113 3.63572 5.06233C4.00343 4.70481 4.55628 4.59856 5.03714 4.79231C5.518 4.98482 5.83043 5.44113 5.83043 5.94614C5.83043 7.34618 5.92043 8.41246 6.34214 9.26373C6.57357 9.73125 6.93486 10.1888 7.55715 10.5975C7.70629 9.27125 7.97886 7.65493 8.34658 6.12239C8.63586 4.91485 8.99585 3.7098 9.42528 2.70477C9.63999 2.20101 9.883 1.72346 10.1581 1.30969C10.4256 0.907181 10.7702 0.498489 11.215 0.20973C11.5223 0.0109736 11.9029 -0.0503198 12.259 0.0421831ZM12.727 16.4014C11.2214 17.8664 8.77857 17.8664 7.273 16.4014C6.51957 15.6701 6.14286 14.7101 6.14286 13.7501C6.14286 13.7501 7.273 14.3751 9.35714 14.3751C9.35714 13.1251 10 9.37497 10.9643 8.74995C11.6071 9.99999 11.9749 10.3663 12.727 11.0988C13.4804 11.8301 13.8571 12.7901 13.8571 13.7501C13.8571 14.7101 13.4804 15.6701 12.727 16.4014Z"
                                        fill="#FF6700"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1044_7395">
                                        <rect
                                          width="25"
                                          height="25"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <div className="black text-xl">
                                    {t("yourSaving")}:
                                  </div>
                                </div>

                                <div className="black text-xl bold">
                                  {raw.slump_deviation_week < 0
                                    ? "0 " + t("$")
                                    : Math.round(
                                        (raw.slump_deviation_week / 25) *
                                          raw.total_cube_week *
                                          0.5
                                      ) +
                                      " " +
                                      t("$")}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="black text-xl flex">
                            <div className="flex">
                              <svg
                                width="100"
                                height="100"
                                viewBox="0 0 100 100"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0807 14.0694C10.4213 14.0399 9.87595 14.3369 9.58538 14.8415C7.45238 18.4711 5.3988 22.1258 3.32622 25.791C3.12933 26.1395 3.07361 26.5502 3.1706 26.9385L7.74822 45.249L3.20416 58.8783C3.15101 59.0378 3.12447 59.2048 3.12478 59.3725C3.12166 63.5453 3.13104 67.7005 3.13104 71.8694C3.12792 72.7323 3.82453 73.4347 4.68743 73.4381H12.622C13.3895 78.7206 17.9547 82.8039 23.4435 82.8039C28.9323 82.8039 33.484 78.7206 34.2498 73.4381H60.9405C63.0243 73.4381 63.0243 70.3131 60.9405 70.3131H34.2528C33.491 65.0261 28.9355 60.9352 23.4434 60.9352C20.4764 60.9352 17.7781 62.1331 15.8018 64.0631H6.24981V59.6259L10.858 45.8045C10.9519 45.5228 10.9636 45.2198 10.8916 44.9317L6.35362 26.786L7.43393 24.8755L15.3868 45.6124L15.6249 59.4001C15.6405 60.2522 16.3351 60.9353 17.1874 60.9352H23.4434H47.0854C47.6466 60.9357 48.165 60.6352 48.4435 60.1478L53.8451 50.6966L56.2498 52.375V64.0631H37.4205C35.2578 64.1724 35.421 67.2976 37.5028 67.1882H66.6959C66.0166 68.6106 65.6217 70.1931 65.6217 71.8696C65.6217 77.8917 70.5341 82.804 76.5562 82.804C82.0449 82.804 86.607 78.7206 87.3746 73.4383H95.3123C96.18 73.4414 96.8842 72.7373 96.8809 71.8696V65.6195C96.8778 64.7566 96.1752 64.0598 95.3123 64.0631H93.7559V46.8757C93.7549 46.7234 93.7305 46.5727 93.6857 46.4268L89.0318 30.8994C88.2409 28.2606 86.8346 26.5629 84.3779 26.5629H67.1904C64.6205 26.5629 62.4968 28.6776 62.4968 31.2474V59.3664C62.4968 61.4502 65.6218 61.4502 65.6218 59.3664V31.2474C65.6218 30.3547 66.2977 29.691 67.1904 29.691H84.3779C85.416 29.691 85.7295 30.7798 86.0045 31.696L90.6279 47.1075V64.063H84.1978C82.2215 62.1329 79.5232 60.9348 76.5562 60.9348C73.5893 60.9348 70.8972 62.133 68.9237 64.063H59.3748V51.5599C59.3749 51.049 59.1253 50.5705 58.7065 50.2781L54.2295 47.1531C53.4765 46.6287 52.436 46.8632 51.9804 47.6599L48.361 53.9923L33.6576 51.3952L47.0457 28.1957L56.6099 39.6429L55.1054 42.2431C54.0595 44.0489 56.7717 45.6143 57.8123 43.8055L59.86 40.2594C60.1878 39.6919 60.1269 38.9805 59.7074 38.4772L48.01 24.4817C47.8934 24.34 47.753 24.2207 47.5949 24.1274L36.7673 17.8775C36.595 17.7783 36.4055 17.7134 36.2088 17.685L11.0807 14.0694ZM11.7613 17.3193L33.4806 20.4505L22.3722 39.6888C21.3306 41.4935 24.0375 43.056 25.0791 41.2514L36.5599 21.3691L44.6836 26.0567L30.615 50.4097L24.127 46.6652C23.2944 46.1845 22.4098 46.5381 22.0243 47.196C21.6212 47.8843 21.6768 48.856 22.5279 49.3475L30.4075 53.8977C30.5643 53.9887 30.7357 54.0518 30.9141 54.0837L46.713 56.8761L46.179 57.81H18.7223L18.5087 45.2824C18.5056 45.1005 18.4703 44.9209 18.405 44.7515L9.42974 21.3567L11.7613 17.3193ZM70.3184 32.804C69.4543 32.7993 68.7502 33.4962 68.7468 34.3604V43.7507C68.7499 44.6148 69.4543 45.312 70.3184 45.3071H74.3528L77.017 47.9836C77.3122 48.2741 77.7107 48.4353 78.1248 48.4323H85.6565C86.6964 48.4264 87.4402 47.4247 87.1458 46.4273L83.4074 33.9243C83.2112 33.2601 82.6014 32.8043 81.909 32.8042L70.3184 32.804ZM71.8748 35.9291H80.7432L83.5569 45.3071H78.7718L76.1076 42.6429C75.8144 42.3482 75.4157 42.1822 74.9998 42.1822H71.8748V35.9291ZM70.3184 51.5572C68.2331 51.5572 68.2331 54.6851 70.3184 54.6851H73.4434C75.5288 54.6851 75.5288 51.5572 73.4434 51.5572H70.3184ZM23.4434 64.0631C27.7766 64.0631 31.2498 67.5364 31.2498 71.8696C31.2498 76.2028 27.7766 79.6913 23.4434 79.6913C19.1102 79.6913 15.6218 76.2028 15.6218 71.8696C15.6218 67.5364 19.1102 64.0631 23.4434 64.0631ZM76.5562 64.0631C80.8894 64.0631 84.3779 67.5364 84.3779 71.8696C84.3779 76.2028 80.8894 79.6913 76.5562 79.6913C72.223 79.6913 68.7468 76.2028 68.7468 71.8696C68.7468 67.5364 72.223 64.0631 76.5562 64.0631ZM6.24369 67.1882H13.571C13.1055 68.1609 12.7782 69.2096 12.6188 70.3132H6.24369V67.1882ZM23.4434 67.1882C20.8731 67.1882 18.7468 69.2993 18.7468 71.8696C18.7467 74.4399 20.8731 76.5662 23.4434 76.5662C26.0138 76.5662 28.1248 74.4399 28.1248 71.8696C28.1248 69.2993 26.0137 67.1882 23.4434 67.1882ZM76.5562 67.1882C73.9859 67.1882 71.8748 69.2993 71.8748 71.8696C71.8748 74.4399 73.9859 76.5662 76.5562 76.5662C79.1266 76.5662 81.2529 74.4399 81.2529 71.8696C81.2528 69.2993 79.1265 67.1882 76.5562 67.1882ZM86.4286 67.1882H93.7559V70.3132H87.3777C87.2184 69.2097 86.8941 68.1608 86.4286 67.1882ZM23.4434 70.3132C24.3249 70.3132 24.9998 70.9882 24.9998 71.8696C24.9998 72.751 24.3249 73.4383 23.4434 73.4383C22.562 73.4383 21.8717 72.7511 21.8718 71.8696C21.8718 70.9881 22.562 70.3132 23.4434 70.3132ZM76.5562 70.3132C77.4377 70.3132 78.1248 70.9882 78.1248 71.8696C78.1248 72.751 77.4377 73.4383 76.5562 73.4383C75.6748 73.4383 74.9998 72.7511 74.9998 71.8696C74.9998 70.9881 75.6748 70.3132 76.5562 70.3132Z"
                                  fill="#FF6700"
                                />
                              </svg>
                            </div>
                            <Divider type="vertical" />

                            <div className="flex flexCol items-start justify-center">
                              <div className="black text-xl ">
                                {raw.total_cube_week !== null
                                  ? raw.total_cube_week + " " + t("kob")
                                  : "-"}
                              </div>
                              <div className="black text-xl ">
                                {raw.number_of_deliveries_week !== null
                                  ? raw.number_of_deliveries_week +
                                    " " +
                                    t("deliveries")
                                  : `0  ${t("deliveries")}`}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}

                      {this.displayMode === "day" && (
                        <div className="flex flex-col">
                          <div className="flex gap-3">
                            <div className="flex gap-3 flexCol">
                              <div className="flex gap-2">
                                <div className="flex">
                                  <svg
                                    width="30"
                                    height="30"
                                    viewBox="0 0 30 30"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      opacity="0.99"
                                      d="M5.80821 23C5.3678 24.4615 4.77337 26.4341 4.3884 27.7117C4.19498 28.3535 4.67556 29 5.34593 29H24.6544C25.3248 29 25.8056 28.3543 25.6122 27.7124C25.0092 25.7114 23.829 21.7949 22.9868 19M5.80821 23C7.66642 16.8335 10.503 7.42034 10.8417 6.29617C10.8642 6.22155 10.8775 6.14588 10.8821 6.06808L10.9393 5.10185C10.9723 4.54433 10.5291 4.07407 9.9706 4.07407C9.43465 4.07407 9.00017 3.6396 9.00017 3.10365V2C9.00017 1.44772 9.44789 1 10.0002 1H20.0002C20.5525 1 21.0002 1.44772 21.0002 2V3.10365C21.0002 3.6396 20.5657 4.07407 20.0298 4.07407C19.4713 4.07407 19.028 4.54433 19.061 5.10185L19.1182 6.06808C19.1228 6.14588 19.1355 6.2194 19.158 6.29402C19.4471 7.25345 21.5832 14.3421 22.9868 19M5.80821 23C12.1737 23 16.7595 19 22.9868 19M16.0002 15C16.0002 16.1046 15.1047 17 14.0002 17C12.8956 17 12.0002 16.1046 12.0002 15C12.0002 13.8954 12.8956 13 14.0002 13C15.1047 13 16.0002 13.8954 16.0002 15Z"
                                      stroke="#FF6700"
                                      stroke-width="2"
                                    />
                                  </svg>
                                  <div className="black text-xl  ml-3">
                                    {t("slumpChanges")}:
                                  </div>
                                </div>

                                <div className="black text-xl bold">
                                  {raw.slump_deviation_day !== null
                                    ? +raw.slump_deviation_day + " " + t("mm")
                                    : "-"}
                                </div>
                              </div>

                              <div className="flex gap-2">
                                <div className="flex gap-2">
                                  <svg
                                    className="fire-icon"
                                    width="25"
                                    height="25"
                                    viewBox="0 0 25 25"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g clip-path="url(#clip0_1044_7395)">
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M12.259 0.0421831C12.6151 0.133436 12.9134 0.36967 13.0793 0.69093C13.7003 1.89972 14.1644 2.63353 14.6311 3.22854C15.1043 3.83106 15.6031 4.32355 16.3643 5.06233C18.1206 6.77113 19 9.01246 19 11.25C19 13.4876 18.1206 15.7289 16.3643 17.4377C12.8491 20.8541 7.15086 20.8541 3.63572 17.4377C1.87943 15.7289 1 13.4876 1 11.25C1 9.01246 1.87943 6.77113 3.63572 5.06233C4.00343 4.70481 4.55628 4.59856 5.03714 4.79231C5.518 4.98482 5.83043 5.44113 5.83043 5.94614C5.83043 7.34618 5.92043 8.41246 6.34214 9.26373C6.57357 9.73125 6.93486 10.1888 7.55715 10.5975C7.70629 9.27125 7.97886 7.65493 8.34658 6.12239C8.63586 4.91485 8.99585 3.7098 9.42528 2.70477C9.63999 2.20101 9.883 1.72346 10.1581 1.30969C10.4256 0.907181 10.7702 0.498489 11.215 0.20973C11.5223 0.0109736 11.9029 -0.0503198 12.259 0.0421831ZM12.727 16.4014C11.2214 17.8664 8.77857 17.8664 7.273 16.4014C6.51957 15.6701 6.14286 14.7101 6.14286 13.7501C6.14286 13.7501 7.273 14.3751 9.35714 14.3751C9.35714 13.1251 10 9.37497 10.9643 8.74995C11.6071 9.99999 11.9749 10.3663 12.727 11.0988C13.4804 11.8301 13.8571 12.7901 13.8571 13.7501C13.8571 14.7101 13.4804 15.6701 12.727 16.4014Z"
                                        fill="#FF6700"
                                      />
                                    </g>
                                    <defs>
                                      <clipPath id="clip0_1044_7395">
                                        <rect
                                          width="25"
                                          height="25"
                                          fill="white"
                                        />
                                      </clipPath>
                                    </defs>
                                  </svg>
                                  <div className="black text-xl">
                                    {t("yourSaving")}:
                                  </div>
                                </div>

                                <div className="black text-xl bold">
                                  {raw.slump_deviation_day < 0
                                    ? "0 " + t("$")
                                    : Math.round(
                                        (raw.slump_deviation_day / 25) *
                                          raw.total_cube_day *
                                          0.5
                                      ) +
                                      " " +
                                      t("$")}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="black text-xl flex">
                            <div className="flex">
                              <svg
                                width="100"
                                height="100"
                                viewBox="0 0 100 100"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M11.0807 14.0694C10.4213 14.0399 9.87595 14.3369 9.58538 14.8415C7.45238 18.4711 5.3988 22.1258 3.32622 25.791C3.12933 26.1395 3.07361 26.5502 3.1706 26.9385L7.74822 45.249L3.20416 58.8783C3.15101 59.0378 3.12447 59.2048 3.12478 59.3725C3.12166 63.5453 3.13104 67.7005 3.13104 71.8694C3.12792 72.7323 3.82453 73.4347 4.68743 73.4381H12.622C13.3895 78.7206 17.9547 82.8039 23.4435 82.8039C28.9323 82.8039 33.484 78.7206 34.2498 73.4381H60.9405C63.0243 73.4381 63.0243 70.3131 60.9405 70.3131H34.2528C33.491 65.0261 28.9355 60.9352 23.4434 60.9352C20.4764 60.9352 17.7781 62.1331 15.8018 64.0631H6.24981V59.6259L10.858 45.8045C10.9519 45.5228 10.9636 45.2198 10.8916 44.9317L6.35362 26.786L7.43393 24.8755L15.3868 45.6124L15.6249 59.4001C15.6405 60.2522 16.3351 60.9353 17.1874 60.9352H23.4434H47.0854C47.6466 60.9357 48.165 60.6352 48.4435 60.1478L53.8451 50.6966L56.2498 52.375V64.0631H37.4205C35.2578 64.1724 35.421 67.2976 37.5028 67.1882H66.6959C66.0166 68.6106 65.6217 70.1931 65.6217 71.8696C65.6217 77.8917 70.5341 82.804 76.5562 82.804C82.0449 82.804 86.607 78.7206 87.3746 73.4383H95.3123C96.18 73.4414 96.8842 72.7373 96.8809 71.8696V65.6195C96.8778 64.7566 96.1752 64.0598 95.3123 64.0631H93.7559V46.8757C93.7549 46.7234 93.7305 46.5727 93.6857 46.4268L89.0318 30.8994C88.2409 28.2606 86.8346 26.5629 84.3779 26.5629H67.1904C64.6205 26.5629 62.4968 28.6776 62.4968 31.2474V59.3664C62.4968 61.4502 65.6218 61.4502 65.6218 59.3664V31.2474C65.6218 30.3547 66.2977 29.691 67.1904 29.691H84.3779C85.416 29.691 85.7295 30.7798 86.0045 31.696L90.6279 47.1075V64.063H84.1978C82.2215 62.1329 79.5232 60.9348 76.5562 60.9348C73.5893 60.9348 70.8972 62.133 68.9237 64.063H59.3748V51.5599C59.3749 51.049 59.1253 50.5705 58.7065 50.2781L54.2295 47.1531C53.4765 46.6287 52.436 46.8632 51.9804 47.6599L48.361 53.9923L33.6576 51.3952L47.0457 28.1957L56.6099 39.6429L55.1054 42.2431C54.0595 44.0489 56.7717 45.6143 57.8123 43.8055L59.86 40.2594C60.1878 39.6919 60.1269 38.9805 59.7074 38.4772L48.01 24.4817C47.8934 24.34 47.753 24.2207 47.5949 24.1274L36.7673 17.8775C36.595 17.7783 36.4055 17.7134 36.2088 17.685L11.0807 14.0694ZM11.7613 17.3193L33.4806 20.4505L22.3722 39.6888C21.3306 41.4935 24.0375 43.056 25.0791 41.2514L36.5599 21.3691L44.6836 26.0567L30.615 50.4097L24.127 46.6652C23.2944 46.1845 22.4098 46.5381 22.0243 47.196C21.6212 47.8843 21.6768 48.856 22.5279 49.3475L30.4075 53.8977C30.5643 53.9887 30.7357 54.0518 30.9141 54.0837L46.713 56.8761L46.179 57.81H18.7223L18.5087 45.2824C18.5056 45.1005 18.4703 44.9209 18.405 44.7515L9.42974 21.3567L11.7613 17.3193ZM70.3184 32.804C69.4543 32.7993 68.7502 33.4962 68.7468 34.3604V43.7507C68.7499 44.6148 69.4543 45.312 70.3184 45.3071H74.3528L77.017 47.9836C77.3122 48.2741 77.7107 48.4353 78.1248 48.4323H85.6565C86.6964 48.4264 87.4402 47.4247 87.1458 46.4273L83.4074 33.9243C83.2112 33.2601 82.6014 32.8043 81.909 32.8042L70.3184 32.804ZM71.8748 35.9291H80.7432L83.5569 45.3071H78.7718L76.1076 42.6429C75.8144 42.3482 75.4157 42.1822 74.9998 42.1822H71.8748V35.9291ZM70.3184 51.5572C68.2331 51.5572 68.2331 54.6851 70.3184 54.6851H73.4434C75.5288 54.6851 75.5288 51.5572 73.4434 51.5572H70.3184ZM23.4434 64.0631C27.7766 64.0631 31.2498 67.5364 31.2498 71.8696C31.2498 76.2028 27.7766 79.6913 23.4434 79.6913C19.1102 79.6913 15.6218 76.2028 15.6218 71.8696C15.6218 67.5364 19.1102 64.0631 23.4434 64.0631ZM76.5562 64.0631C80.8894 64.0631 84.3779 67.5364 84.3779 71.8696C84.3779 76.2028 80.8894 79.6913 76.5562 79.6913C72.223 79.6913 68.7468 76.2028 68.7468 71.8696C68.7468 67.5364 72.223 64.0631 76.5562 64.0631ZM6.24369 67.1882H13.571C13.1055 68.1609 12.7782 69.2096 12.6188 70.3132H6.24369V67.1882ZM23.4434 67.1882C20.8731 67.1882 18.7468 69.2993 18.7468 71.8696C18.7467 74.4399 20.8731 76.5662 23.4434 76.5662C26.0138 76.5662 28.1248 74.4399 28.1248 71.8696C28.1248 69.2993 26.0137 67.1882 23.4434 67.1882ZM76.5562 67.1882C73.9859 67.1882 71.8748 69.2993 71.8748 71.8696C71.8748 74.4399 73.9859 76.5662 76.5562 76.5662C79.1266 76.5662 81.2529 74.4399 81.2529 71.8696C81.2528 69.2993 79.1265 67.1882 76.5562 67.1882ZM86.4286 67.1882H93.7559V70.3132H87.3777C87.2184 69.2097 86.8941 68.1608 86.4286 67.1882ZM23.4434 70.3132C24.3249 70.3132 24.9998 70.9882 24.9998 71.8696C24.9998 72.751 24.3249 73.4383 23.4434 73.4383C22.562 73.4383 21.8717 72.7511 21.8718 71.8696C21.8718 70.9881 22.562 70.3132 23.4434 70.3132ZM76.5562 70.3132C77.4377 70.3132 78.1248 70.9882 78.1248 71.8696C78.1248 72.751 77.4377 73.4383 76.5562 73.4383C75.6748 73.4383 74.9998 72.7511 74.9998 71.8696C74.9998 70.9881 75.6748 70.3132 76.5562 70.3132Z"
                                  fill="#FF6700"
                                />
                              </svg>
                            </div>
                            <Divider type="vertical" />

                            <div className="flex flexCol items-start justify-center">
                              <div className="black text-xl ">
                                {raw.total_cube_day !== null
                                  ? raw.total_cube_day + " " + t("kob")
                                  : "-"}
                              </div>
                              <div className="black text-xl ">
                                {raw.number_of_deliveries_day !== null
                                  ? raw.number_of_deliveries_day +
                                    " " +
                                    t("deliveries")
                                  : `0  ${t("deliveries")}`}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </table>
                  </div>
                </a>
              ))
            ) : (
              <div className="no-data">No data</div>
            )}

            {/* <ConcreteSlump concreateCode={this.concreateCode} displayMode={this.displayMode} previewMODE={true}/> */}
          </div>
        </div>
      </ReadDataStyled>
    );
  }
}

export default withRouter(SlumpChanges);
